module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "open": _vm.openModal
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h3', {
    staticClass: "modal-title"
  }, [_vm._v("Find your doctor")])]), _vm._v(" "), _c('div', {
    staticClass: "practice-search-modal-body"
  }, [_c('h4', [_vm._v("Search for the practice that you would like to connect to")]), _vm._v(" "), _c('practice-search', {
    on: {
      "practice": _vm.practice
    }
  })], 1), _vm._v(" "), (_vm.chosenPractice) ? _c('div', {
    staticClass: "text-center alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n    You have selected " + _vm._s(_vm._f("upperCase")(_vm.chosenPractice.name)) + ". Would you like to continue?\n  ")]) : _vm._e(), _vm._v(" "), (_vm.errorOccured) ? _c('div', {
    staticClass: "text-center alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Could not load the practice forms. Please contact "), _c('u', [_vm._v("support@logbox.co.za")]), _vm._v(" for assistance.\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "float-left col-xs-4 col-xs-offset-1"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-block btn-close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', {
    staticClass: "float-right col-xs-4 col-xs-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "disabled": !_vm.chosenPractice
    },
    on: {
      "click": function($event) {
        return _vm.redirectToKioskSite(_vm.link)
      }
    }
  }, [_vm._v("Continue")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e86ee602"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/modals/KioskModal.vue
// module id = 679
// module chunks = 5